import { expansionPanelItem }from './expansionPanel';


export const othersDetailSectionItems: expansionPanelItem[] = [
  {
    title: 'Architecture',
    content: '業務では、クリーンアーキテクチャの考えに沿った設計で開発を行うことが多いです。レイヤー化されたアーキテクチャで、疎結合な状態にして、メンテナンスやテストがしやすい設計にします。'
  },
  {
    title: 'Architecture(FrontEnd)',
    content: 'React/NextやVue/Nuxtなどのフロンエンドの開発では、関数ベースを基本としたアーキテクチャで作成します。関数ベースで書くことで、副作用の少ないプログラミングを目指します。(最近は、純粋関数型のElmに興味アリ。)'
  },
  {
    title: 'Microservices',
    content: '業務ではマイクロサービスで開発をしています。マイクロサービスの辛みもだんだんと理解できてきたので、サービスの規模などに応じて適切に選定します。'
  },
  {
    title: 'Linux',
    content: '元々インフラエンジニアとして業務をしていたため、一般的なプログラマーよりは、Linuxコマンドや仕組みについて比較的詳しいです。'
  },
  {
    title: 'Machine Learning',
    content: '副業で、ゲームアプリ内の5桁の数字認識を、機械学習し自動突破させるモデルを作成しました。最初はSVMで実装し、正解率がよくなかったので、結局ランダムフォレストで実装しました。(現在は機械学習に興味がないので、副業等でも受け付けていません。)'
  },
];
